import React from 'react';
import { Button } from '../../../components/Bootstrap';
import { NobleModal } from '../../../components';
import { TrashCan } from './TrashCan';

interface DeleteModalProps {
  open: boolean;
  toggle: () => void;
  onDelete: () => void;
}

interface DeleteModalState {
  name: string;
}

export class DeleteModal extends React.Component<DeleteModalProps, DeleteModalState> {
  render() {
    return (
      <NobleModal size='lg' isOpen={this.props.open} toggle={this.props.toggle}>
        <NobleModal.Title title='Delete Menu' />
        <NobleModal.Body>
          <div className='text-center'>
            <TrashCan />
          </div>
          <p className='menu-modal-desc text-center'>Are you sure you want to delete the currently selected menu?</p>
          <div className='text-center menu-modal-btns'>
            <Button type='button' color='link' className='me-4' onClick={this.props.toggle}>
              Cancel
            </Button>{' '}
            <Button type='submit' color='primary' onClick={this.props.onDelete}>
              Delete
            </Button>
          </div>
        </NobleModal.Body>
      </NobleModal>
    );
  }
}
